import React, { Component } from "react";
import renderHTML from "react-render-html";
import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

// slideshow
import ImageGallery from "react-image-gallery";
import VideoPlayer from "components/videoPlayer/videoPlayer";
import "react-image-gallery/styles/css/image-gallery-no-icon.css";

// dashed line
import DashedLineBreakHeader from "components/dashedLineBreakHeader/dashedLineBreakHeader";

// rich text styles
import "./slideshow.css";
import "./richText.css";

class RichText extends Component {
  render() {
    const document = this.props.richText;
    const options = {
      renderNode: {
        // embedded assets
        [BLOCKS.EMBEDDED_ASSET]: node => {
          const url = node.data.target.fields.file.url;
          if (node.data.target.fields.file.contentType === "video/mp4") {
            return <VideoPlayer src={node.data.target.fields.file.url} />;
          }
          return <img src={url} alt="alt" key={url} />;
        },
        // raw html component
        [BLOCKS.EMBEDDED_ENTRY]: node => {
          if (node.data.target.sys.contentType.sys.id === "image") {
            const url = node.data.target.fields.image.fields.file.url;
            const isSmall = node.data.target.fields.small;
            return (
              <img
                src={url}
                className={isSmall === true ? "small" : ""}
                alt="alt"
              />
            );
          }
          if (node.data.target.sys.contentType.sys.id === "rawHtml") {
            const html = node.data.target.fields.html;
            return <div key={node.data.target.sys.id}>{renderHTML(html)}</div>;
          }
          if (node.data.target.sys.contentType.sys.id === "slideshow") {
            const images = node.data.target.fields.images.map(image => ({
              original: image.fields.file.url,
              thumbnail: image.fields.file.url
            }));
            return (
              <ImageGallery
                items={images}
                showPlayButton={false}
                showThumbnails
                showFullscreenButton={false}
              />
            );
          }
        },
        // slideshow component
        // h1 treatment for titles
        [BLOCKS.HEADING_1]: node => {
          const title = node.content[0].value;
          return <DashedLineBreakHeader title={title} />;
        },
        //
        [INLINES.HYPERLINK]: node => (
            <a href={node.data.uri} target="_blank" rel="noopener noreferrer">
              {node.content[0].value}
            </a>
          )
      }
    };
    return <div>{documentToReactComponents(document, options)}</div>;
  }
}

export default RichText;
